export const IS_REQUIRED_CHECKBOX_TYPE = 'IS_REQUIRED_CHECKBOX_TYPE'
export const text = {
  INTAKE_FORM: 'intake form',
}
export const apiErrorCodes = {
  INTAKE_FORM_NOT_FOUND: 'IntakeFormNotFound',
}
